import React from 'react'
import { FaLinkedinIn } from 'react-icons/fa'
import { BsTwitter } from 'react-icons/bs'
import Container from '../../utils/Container'
import Paragraph from '../../elements/p/Paragraph'
import logo from '../../../medias/logo/logo-rita-3.svg'
import tweeter from '../../../medias/svg/tweeter.svg'
import linkedin from '../../../medias/svg/linkedin.svg'
import { Link } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link';


const Footer = () => {
	return(
		<footer className="mt-36 md:mt-60 pb-10">
			<Container classe="">
				<div className="flex justify-between items-center">
					<div>
		                <HashLink to="/">
		                    <img 
		                        src={logo} 
		                        alt="spécialiste en traduction des langues: Rita nsangou"
		                        title="Rita nsangou est spéciqlisé dans la traduction des langues"
		                        className="w-28 md:w-32"
		                    />
		                </HashLink>
		            </div>

					<div>
		                <div className="flex items-center space-x-5">



		                	<a href="https://www.linkedin.com/in/ritansangou/" target="_blanck">
		                		<img src={linkedin} className="w-8" alt="linkedin" />
		                	</a>
		                	<a href="https://twitter.com/rita_nsangou" target="_blanck">
		                		<img src={tweeter} className="w-6" alt="linkedin" />
		                	</a>
		                </div>
		            </div>
				</div>
				<div className="flex flex-col md:flex-row justify-between mt-3">
					<ul className="flex my-10 md:my-2 flex-col md:flex-row items-center space-y-8 md:space-y-0 md:space-x-10 text-secondary text-base">
	                    <HashLink to="/" className=" text-gray-500 font-nunito hover:text-primary animate">
	                        Accueil
	                    </HashLink>
	                    <HashLink to="/about" className=" text-gray-500 font-nunito hover:text-primary animate">
	                        à propos
	                    </HashLink>
	                    <HashLink to="/faqs" className=" text-gray-500 font-nunito hover:text-primary animate">
	                        FAQS
	                    </HashLink>
	                    <HashLink to="/contact" className=" text-gray-500 font-nunito hover:text-primary animate">
	                        Contact
	                    </HashLink>
	                </ul>

	                <Paragraph classe="text-xs text-center md:text-left mt-5 md:mt-0 mb-3"> 
	                	{/*<spa>&copy;</spa>*/}© 2022 RITA, ALL RIGHTS RESERVED. 
	                	{/*The illustrations were provided by
	                	<a 
							href="https://storyset.com/"
							target="_blanck" 
							className="font-italic ml-1 font-semibold">
							storyset
						</a>*/}
	                </Paragraph>
				</div>
				<div className="w-full h-0.5 bg-gray-200"></div>
				<Paragraph classe="italic text-center mt-8">
					designed and developed by 
					<a 
						href="https://www.linkedin.com/in/ngimdock-zemfack/"
						target="_blanck" 
						className="font-italic text-primary font-bold ml-1.5 underline hover:underline-offset-4 animate">ngimdock zemfack</a>
				</Paragraph>
				
			</Container>
		</footer>
	)
}

export default Footer